var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',[_vm._v("1401 © همیار مکانیک کوشا")])])])])
}]

export { render, staticRenderFns }